import _ from 'lodash';


const canSaveDraft = (state) =>{
  return state.invoice.status!=null && state.invoice.status.code==="DRAFT" && state.invoice.total>0;
}

const canSaveAndSend = (state) =>{
  if(state.invoice.status==null) return true;
  return state.invoice.status!=null && (state.invoice.status.code==="DRAFT" || state.invoice.status.code==="SENT")   && state.invoice.total>0;
}

const canSavePaid = (state) =>{
  return state.invoice.status!=null && state.invoice.status.code==="DRAFT" && state.invoice.total==0;
}

const getInvoicePaymentOptions = (state)=>{
  let paymentOptions = [];
  _.forEach(state.invoice.paymentOptions, option=>{
    paymentOptions.push(option.id);
  })
  return paymentOptions;
}

const customerName = (state) => (customer) =>{
  return customer.usual_name!=null?customer.usual_name:customer.name;
}

function getCreditUsed(state){
  let credit = 0.00;
  if(state.invoice !== null && state.invoice.creditNotes !== null){
    _.forEach(state.invoice.creditNotes, c=>{
      credit+=c.amount;
    })
  }
  return credit;
}

function calculateCreditFromCreditNote(state){
  return( state.invoice.creditNote !=null ? state.invoice.creditNote.total : 0.00);
}

function calculateCredit(state){
  let credit = calculateCreditFromCreditNote(state);
  credit+=getCreditUsed(state);
  return credit;
}

const creditNotes_credit = (state) =>{
  return getCreditUsed(state);
}
const creditNote_credit = (state) =>{
  return calculateCreditFromCreditNote(state);
}

const creditUsed = (state) =>{
  return calculateCredit(state);
}

const amountPaid = (state) => {
  let amount = 0;
  if (state.invoice != null) {
    _.forEach(state.invoice.payments, payment => {
      amount += payment.amount;
    })
  }

  return amount;
}

const balanceToPay = (state) => {
  // if (state.invoice.balance != null && state.invoice.balance.outstanding != null) {
  //   return state.invoice.balance.outstanding;
  // }
  return state.invoice.total - creditNotes_credit(state) - amountPaid(state);
}

const activeCustomerContacts = (state) =>
  _.filter(state.customerContacts, c => c.active === true);

export default {
  canSaveDraft,
  canSaveAndSend,
  getInvoicePaymentOptions,
  customerName,
  canSavePaid,
  balanceToPay,
  creditUsed,
  creditNotes_credit,
  creditNote_credit,
  activeCustomerContacts,
  amountPaid
};
